import { Clock, Facebook, Instagram, Linkedin, Mail, MapPin, MessageCircle, Navigation, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { mapsEmbed, mapsLink, telLink, waLink } from "@/lib/constants";

const Row = ({ icon: Icon, label, children, testid }) => (
  <div className="flex gap-4 py-4" data-testid={testid}>
    <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-[#1E6FD9]/10 text-[#1E6FD9]"><Icon className="h-[18px] w-[18px]" /></span>
    <div className="min-w-0">
      <p className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-400">{label}</p>
      <div className="mt-1 break-words text-[15px] font-medium text-[#0B2545]">{children}</div>
    </div>
  </div>
);

const SOCIAL = [["facebook", Facebook], ["instagram", Instagram], ["linkedin", Linkedin]];

export const ContactSection = ({ center }) => {
  const q = center.map_query || center.address;
  const actions = [
    [Navigation, "Abrir en Google Maps", mapsLink(q), "contact-maps-button", true],
    [Phone, "Llamar", telLink(center.phone), "contact-call-button", false],
    [MessageCircle, "Enviar WhatsApp", waLink(center.whatsapp), "contact-whatsapp-button", true],
    [Mail, "Enviar correo", `mailto:${center.email || ""}`, "contact-email-button", false],
  ];
  return (
    <section id="contacto" className="bg-[#F5F7FA] py-24 lg:py-32" data-testid="contact-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#14B8A6]">Contacto</p>
        <h2 className="mt-3 font-display text-3xl font-extrabold tracking-tight text-[#0B2545] sm:text-4xl">Estamos cerca de ti</h2>
        <div className="mt-12 grid gap-8 lg:grid-cols-12">
          <div className="rounded-[1.5rem] border border-slate-200/80 bg-white p-6 sm:p-8 lg:col-span-5">
            <div className="divide-y divide-slate-100">
              <Row icon={MapPin} label="Dirección" testid="contact-address">{center.address}</Row>
              <Row icon={Phone} label="Teléfono" testid="contact-phone">{center.phone}</Row>
              <Row icon={MessageCircle} label="WhatsApp" testid="contact-whatsapp">+{String(center.whatsapp || "").replace(/\D/g, "")}</Row>
              <Row icon={Mail} label="Correo" testid="contact-email">{center.email}</Row>
              <Row icon={Clock} label="Horarios" testid="contact-hours">
                {(center.hours || []).map((h) => <span key={h} className="block">{h}</span>)}
              </Row>
            </div>
            <div className="mt-4 flex gap-2" data-testid="contact-social">
              {SOCIAL.filter(([k]) => center[k]).map(([k, Icon]) => (
                <a key={k} href={center[k]} target="_blank" rel="noopener noreferrer" aria-label={k}
                   className="grid h-10 w-10 place-items-center rounded-full border border-slate-200 text-slate-600 transition-colors hover:border-[#1E6FD9] hover:text-[#1E6FD9]"
                   data-testid={`contact-social-${k}`}><Icon className="h-4 w-4" /></a>
              ))}
            </div>
          </div>
          <div className="flex flex-col gap-4 lg:col-span-7">
            <div className="aspect-[4/3] overflow-hidden rounded-[1.5rem] border border-slate-200/80 bg-white sm:aspect-[16/10] lg:flex-1">
              {q && <iframe title="Mapa Centro Médico IEMED" src={mapsEmbed(q)} className="h-full w-full border-0" loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade" data-testid="contact-map" />}
            </div>
            <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
              {actions.map(([Icon, label, href, testid, ext]) => (
                <Button key={testid} asChild variant="outline"
                        className="h-auto flex-col gap-1.5 rounded-2xl border-slate-200 bg-white py-4 text-xs font-semibold text-[#0B2545] hover:border-[#1E6FD9] hover:text-[#1E6FD9] sm:text-sm">
                  <a href={href} {...(ext ? { target: "_blank", rel: "noopener noreferrer" } : {})} data-testid={testid}>
                    <Icon className="h-5 w-5" /> {label}
                  </a>
                </Button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
